import { Building2, Eye } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function EmpresaSelector() {
  const { user, empresas, activeEmpresa, setEmpresa } = useAuth();
  if (!user || empresas.length === 0) return null;
  const isSuper = !!user.is_super_admin;
  const showSelect = isSuper || empresas.length > 1;

  if (!showSelect) {
    const only = empresas[0];
    return (
      <div className="px-4 py-2.5 border-b border-slate-200 bg-slate-50 flex items-center gap-2" data-testid="empresa-badge">
        <Building2 className="h-3.5 w-3.5 text-blue-700" />
        <span className="text-xs font-semibold text-slate-700 truncate">
          {only?.short_name || only?.name}
        </span>
      </div>
    );
  }

  return (
    <div className="px-4 py-3 border-b border-slate-200 bg-slate-50 space-y-1">
      <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 flex items-center gap-1.5">
        <Building2 className="h-3 w-3" /> Empresa
      </label>
      <select
        data-testid="empresa-selector"
        value={activeEmpresa || ""}
        onChange={(e) => setEmpresa(e.target.value)}
        className="w-full border border-slate-300 rounded-md px-2 h-9 text-sm bg-white font-medium text-slate-800"
      >
        {isSuper && (
          <option value="all" data-testid="empresa-all-option">
            Todas as empresas
          </option>
        )}
        {empresas.map((e) => (
          <option key={e.id} value={e.id} data-testid={`empresa-option-${e.id}`}>
            {e.name}
          </option>
        ))}
      </select>
      {activeEmpresa === "all" && (
        <div
          className="flex items-center gap-1.5 text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1"
          data-testid="empresa-all-readonly-banner"
        >
          <Eye className="h-3 w-3" /> Consolidado — somente leitura
        </div>
      )}
    </div>
  );
}
